import createMessage from "./createMessage";
import protoRoot from "../proto-root";

const name = "motionInfoPacket";

function create() {
  const MotionInfoPacket = protoRoot.lookupType(`comm.MotionInfoPacket`);
  const motionInfoPacket = MotionInfoPacket.create({});

  return createMessage({
    [name]: motionInfoPacket
  });
}

export default {
  create,
  name
};

// message MotionInfoPacket {
//     // can contain motion info in the future...
// }
